import script from "./error-block.vue?vue&type=script&setup=true&lang=js"
export * from "./error-block.vue?vue&type=script&setup=true&lang=js"

import "./error-block.vue?vue&type=style&index=0&id=59a2b8bd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a2b8bd"]])

export default __exports__